import {
  createUserWithEmailAndPassword,
  getAuth,
  sendEmailVerification,
  sendPasswordResetEmail,
  signInWithEmailAndPassword
} from 'firebase/auth';
import app from '.';

// Initialize Firebase Authentication and get a reference to the service
const auth = getAuth(app);

export default auth;

export const signIn = async (email: string, password: string) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const signOut = async () => {
  try {
    await auth.signOut();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error signing out!');
  }
};

export const resetPassword = async (email: string) => {
  await sendPasswordResetEmail(auth, email);
};

export const signUp = async (email: string, password: string) => {
  try {
    const usr = await createUserWithEmailAndPassword(auth, email, password);
    // Current url as email verification link
    try {
      await sendEmailVerification(usr.user, {
        url: window.location.origin + '/onboarding/' + usr.user.email,
        handleCodeInApp: true
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('....', error);
    }
    return usr;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error signing up with password and email!');
    return null;
  }
};
